import { render, staticRenderFns } from "./receivablesInvoiceSummary.vue?vue&type=template&id=540bffed&scoped=true"
import script from "./receivablesInvoiceSummary.vue?vue&type=script&lang=js"
export * from "./receivablesInvoiceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540bffed",
  null
  
)

export default component.exports